module.exports = __webpack_public_path__ + "img/img17.947112e9.svg";